import { ChartType } from 'interfaces/agentSession';

// Fixed inner plot area height. The rendered chart can grow below this to fit multi-line x-axis labels.
export const DEFAULT_STUDY_REPORT_CHART_HEIGHT = 280;
export const KAPLAN_MEIER_STUDY_REPORT_CHART_HEIGHT = DEFAULT_STUDY_REPORT_CHART_HEIGHT * 2;

export const getStudyReportChartHeight = (chartType: ChartType): number =>
  chartType === 'kaplan_meier' ? KAPLAN_MEIER_STUDY_REPORT_CHART_HEIGHT : DEFAULT_STUDY_REPORT_CHART_HEIGHT;
